<template>
  <div>
    <b-modal
      id="modalStatut"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row d-flex justify-content-center mt-n4">
            <div class="col-12">
              <div class="form-group">
                <label for="statut"
                  >Statut de la candidature
                  <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="statuts"
                  :reduce="(statut) => statut.uuid"
                  v-model="form.statut"
                  placeholder="Statut de la candidature"
                >
                  <template v-slot:option="{ nom, couleur }">
                    <h5 style="margin: 0">
                      <i
                        :style="`color: ${couleur}`"
                        class="fa fa-circle mr-1"
                      ></i>
                      {{ nom }}
                    </h5>
                  </template>
                  <template #no-options> Aucune données </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="statut"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('statut'),
                    }"
                  />
                  <has-error :form="form" field="statut"></has-error>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalStatut')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Enregistrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/rh/candidature/candidature';
import Form from 'vform';
export default {
  data() {
    return {
      form: new Form({
        statut: null,
      }),
      titleModal: 'Statut de candidature',
    };
  },
  methods: {
    showModal() {
      this.form.statut = this.currentCandidature.statut;
      this.$bvModal.show('modalStatut');
    },
    submit() {
      this.$bvModal.hide('modalStatut');

      this.form
        .put(URL.STATUER + '/' + this.currentCandidature.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.form.clear();
          this.$emit('onChangeStatut', resp.data.candidature);
        })
        .catch(() => {
          this.$bvModal.show('modalStatut');
        });
    },
  },
  props: ['currentCandidature', 'statuts'],
};
</script>

<style scoped lang="scss"></style>
